import 'css-chunksrc/client/scenes/projectLogs/export/styles.scss';export default {
  "export": "_export_i77ns_1",
  "button": "_button_i77ns_7",
  "content": "_content_i77ns_18",
  "copyIcon": "_copyIcon_i77ns_25"
};